import { TSafeChargeMethodType } from '../../stores/payredeem/types';

import { SupportedPaymentMethodEnum } from './enums';
import { RedemptionProvider } from './redemptions/enums';

export const NOT_SUPPORTED = Symbol('Not supported');

export const RDM_METHOD_BY_STORED_METHOD: Record<TSafeChargeMethodType, RedemptionProvider | typeof NOT_SUPPORTED> = {
  [TSafeChargeMethodType.card]: RedemptionProvider.CARD,
  [TSafeChargeMethodType.bank]: RedemptionProvider.BANK,
  [TSafeChargeMethodType.applepay]: NOT_SUPPORTED,
  [TSafeChargeMethodType.skrill]: RedemptionProvider.SKRILL,
  [TSafeChargeMethodType.bankPaysafe]: RedemptionProvider.ACH,
  [TSafeChargeMethodType.payouts]: RedemptionProvider.PAYOUTS,
  [TSafeChargeMethodType.interac]: RedemptionProvider.INTERAC,
  [TSafeChargeMethodType.sepa]: RedemptionProvider.SEPA,
  [TSafeChargeMethodType.paysafeCard]: RedemptionProvider.PAYSAFECARD,
};

export const EXACT_METHOD_BY_STORED_METHOD: Record<
  TSafeChargeMethodType,
  SupportedPaymentMethodEnum | typeof NOT_SUPPORTED
> = {
  [TSafeChargeMethodType.card]: SupportedPaymentMethodEnum.CARD_REDEEM,
  [TSafeChargeMethodType.bank]: SupportedPaymentMethodEnum.IBT_REDEEM,
  [TSafeChargeMethodType.applepay]: NOT_SUPPORTED,
  [TSafeChargeMethodType.skrill]: SupportedPaymentMethodEnum.SKRILL_REDEEM,
  [TSafeChargeMethodType.bankPaysafe]: SupportedPaymentMethodEnum.ACH_REDEEM,
  [TSafeChargeMethodType.payouts]: SupportedPaymentMethodEnum.PAYOUTS_REDEEM,
  [TSafeChargeMethodType.interac]: SupportedPaymentMethodEnum.INTERAC_REDEEM,
  [TSafeChargeMethodType.sepa]: SupportedPaymentMethodEnum.SEPA_REDEEM,
  [TSafeChargeMethodType.paysafeCard]: SupportedPaymentMethodEnum.PAYSAFECARD_REDEEM,
};
